import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import WithAuth from '../../HOCs/WithAuth'
import HomePageOption from '../../components/HomePageOption'

import {
  getIncompleteCharts,
  getUnapprovedCharts,
  getApprovedCharts,
  getChartsNeedingRevision,
  getChartCounts,
} from './reducers/chartsReducer'

import {
  userIsStudyCoordinator,
  userIsInvestigator,
  // userIsPortalAdmin,
  userIsPharmaVigilance,
  userCanSeeAllRoutes,
  userIsSuperUser,
  userIsDataManager,
  userIsPortalAdmin,
} from '../../functions/userPermissions'

import IncompleteChartsModal from './components/IncompleteChartsModal'
import NewChartConfirmationModal from "./components/NewChartConfirmationModal"
import LoadingScreen from '../../components/LoadingScreen'

import './style.css'

const newChartImg = require('../../static/images/chart-5.png')

const incompleteChartsImg = require('../../static/images/chart-4.png')

const reviewChartsImg = require('../../static/images/chart-1.png')

const reviseChartsImg = require('../../static/images/chart-2.png')

const approvedChartsImg = require('../../static/images/approved-charts.png')

const submittedChartsImg = require('../../static/images/chart-8.png')

const dataManagerRevisionChartsImg = require('../../static/images/chart-6.png')


class ChartsContainer extends Component {

  state = {
    showIncompleteChartsModal: false,
    showNewChartConfirmationModal: false,
  }

  componentDidMount() {
    const { currentUser } = this.props

    if (userIsInvestigator(currentUser) || userIsStudyCoordinator(currentUser) || userCanSeeAllRoutes(currentUser)) {
      this.props.getIncompleteCharts(this.props.alert)
      // this.props.getChartsNeedingRevision(this.props.alert)
    }

    this.props.getChartCounts(this.props.alert)
  }

  componentDidUpdate(prevProps) {
    if (this.props.incompleteCharts.length > 0 && prevProps.incompleteCharts.length === 0) {
      this.setState({ showIncompleteChartsModal: true })
    }
  }

  toggleShowIncompleteCharts = () => {
    this.setState({ showIncompleteChartsModal: !this.state.showIncompleteChartsModal })
  }

  render() {
    const {
      incompleteCharts,
      fetchingIncompleteCharts,
      fetchingChartCounts,
      chartCounts,
      currentUser,
    } = this.props

    const { showNewChartConfirmationModal } = this.state

    if (fetchingIncompleteCharts || fetchingChartCounts) {
      return <LoadingScreen text="Loading" />
    }

    return (
      <div className='ChartsContainer'>

        <IncompleteChartsModal
          show={this.state.showIncompleteChartsModal}
          toggleShow={this.toggleShowIncompleteCharts}
          {...this.props}
        />

        <Row>
          {userIsInvestigator(currentUser) || userIsStudyCoordinator(currentUser) || userCanSeeAllRoutes(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={newChartImg}
                title='New Chart'
                description="Create a new patient chart"
                buttonText="Create New Chart"
                onClick={(e) => {
                  if (chartCounts.approved_chart_count >= 20) {
                    this.setState({ showNewChartConfirmationModal: true })
                  } else {
                    this.props.routerProps.history.push("/charts/new")
                  }
                }}
              />
            </Col>
            :
            null
          }

          { showNewChartConfirmationModal ?
            <NewChartConfirmationModal
              show={ showNewChartConfirmationModal }
              chartCounts={ chartCounts }
              toggleShow={ () => this.setState({ showNewChartConfirmationModal: false }) }
              routerProps={ this.props.routerProps }
            />
            :
            null
          }

          {userIsInvestigator(currentUser) || userIsStudyCoordinator(currentUser) || userCanSeeAllRoutes(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={incompleteChartsImg}
                title={`Incomplete Charts (${incompleteCharts.length})`}
                description="Start where you left off with any charts that you have not completed."
                buttonText="Incomplete Charts"
                onClick={this.toggleShowIncompleteCharts}
              />
            </Col>
            :
            null
          }

          {userIsInvestigator(currentUser) || userCanSeeAllRoutes(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={reviewChartsImg}
                title={`Review Completed Charts (${chartCounts?.unapproved || 0})`}
                description="Review and comment upon your team's completed charts. Mark them as finished or as requiring revisions."
                buttonText="Review Charts"
                onClick={() => this.props.routerProps.history.push('/charts/review')}
              />
            </Col>
            :
            null
          }

          {userIsInvestigator(currentUser) || userIsStudyCoordinator(currentUser) || userCanSeeAllRoutes(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={reviseChartsImg}
                title={`Charts Requiring Revisions (${chartCounts?.requires_revisions || 0})`}
                description="View notes from an investigator and make any necessary revisions to your patient charts."
                buttonText="Revise Charts"
                onClick={() => this.props.routerProps.history.push('/charts/revise')}
              />
            </Col>
            :
            null
          }

          {!userIsPortalAdmin(currentUser) && (userIsInvestigator(currentUser) || userCanSeeAllRoutes(currentUser)) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={dataManagerRevisionChartsImg}
                title={`Charts Requiring Data Validation (${chartCounts?.charts_requiring_data_manager_revisions || 0})`}
                description="Review and respond to data validation requests from the data manager."
                buttonText="View Charts"
                onClick={() => this.props.routerProps.history.push('/charts/review-data-manager-notes')}
              />
            </Col>
            :
            null
          }

          {!userIsInvestigator(currentUser) && (userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) || currentUser.can_view_incomplete_charts) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={dataManagerRevisionChartsImg}
                title={`Charts With Pending Validation Requests (${chartCounts?.charts_requiring_data_manager_revisions || 0})`}
                description="View data validation requests from the data manager."
                buttonText="View Charts"
                onClick={() => this.props.routerProps.history.push('/charts/view-data-manager-notes')}
              />
            </Col>
            :
            null
          }

          {/* {userIsInvestigator(currentUser) || userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={approvedChartsImg}
                title={`Approved Charts (${chartCounts?.approved || 0})`}
                description="View charts that have been completed and approved."
                buttonText="Approved Charts"
                onClick={() => this.props.routerProps.history.push('/charts/approved')}
              />
            </Col>
            :
            null
          } */}

          {userIsDataManager(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={approvedChartsImg}
                title="Validate Approved Charts"
                description="Review and comment upon charts requiring data validation."
                buttonText="Validate Approved Charts"
                onClick={() => this.props.routerProps.history.push('/charts/validate')}
              />
            </Col>
            :
            null
          }

          {!userIsPharmaVigilance(currentUser) && !userIsSuperUser(currentUser) ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={submittedChartsImg}
                title='All Submitted Charts'
                description="View all charts that have been submitted at this site."
                buttonText="All Submitted Charts"
                onClick={() => this.props.routerProps.history.push('/charts/submitted')}
              />
            </Col>
            :
            null
          }

          {userIsSuperUser(currentUser) === true ?
            <Col xs={12} sm={6} md={4} lg={4} className='HomePageOptionContainer'>
              <HomePageOption
                image={submittedChartsImg}
                title='All Charts'
                description="View all charts for your region"
                buttonText="All Charts"
                onClick={() => this.props.routerProps.history.push('/charts/all')}
              />
            </Col>
            :
            null
          }
        </Row>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
    incompleteCharts: state.chartsReducer.incompleteCharts,
    fetchingIncompleteCharts: state.chartsReducer.fetchingIncompleteCharts,
    unapprovedCharts: state.chartsReducer.unapprovedCharts,
    fetchingUnapprovedCharts: state.chartsReducer.fetchingUnapprovedCharts,
    chartsNeedingRevision: state.chartsReducer.chartsNeedingRevision,
    fetchingChartsNeedingRevision: state.chartsReducer.fetchingUnapprovedCharts,
    fetchingApprovedCharts: state.chartsReducer.fetchingApprovedCharts,
    approvedCharts: state.chartsReducer.approvedCharts,
    fetchingChartCounts: state.chartsReducer.fetchingChartCounts,
    chartCounts: state.chartsReducer.chartCounts,
  }
}


const mapDispatchToProps = {
  getIncompleteCharts,
  getUnapprovedCharts,
  getApprovedCharts,
  getChartsNeedingRevision,
  getChartCounts,
}

export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(ChartsContainer))
